<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
body {
    margin: 0;
    padding: 0;
  }
#app {
  padding: 0vh;
  margin: 0 !important;
  
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;  
}

$redColor: rgba(244,67,54,1);
$blueColor:rgba(33,150,243,1);

.flex-center {
  min-height: 100vh;
  
  background: #000;
  
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
      -ms-flex-pack: center;
          justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
      -ms-flex-align: center;
          align-items: center;
}

.flex-bottom {
  min-height: 100vh;
  
  background: #000;
  
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: end ;
  -webkit-justify-content: end ;
      -ms-flex-pack: end ;
          justify-content: end ;
  -webkit-box-align: end ;
  -webkit-align-items: end ;
      -ms-flex-align: end ;
          align-items: end ;
}

.icon-3d {
  margin-right: 1vh;
  margin-left: 1vh;
  color: #fff;
  &:hover {
    filter: drop-shadow(-5px -6px 1px $blueColor) drop-shadow(5px 4px 1px $redColor);    
  }
}
</style>
